import React, { useEffect, useRef, useState } from 'react';
import { SearchOutlined, HeartOutlined } from '@ant-design/icons';
import aiIcon from "../../assets/icons/ai.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import './MobileNavFooter.css';
import menuIcon from '../../assets/icons/menuIcon.svg';

export const MobileNavFooter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const tabs = [
    { key: '/recommend-college-dream', label: 'Match', icon: <img src={aiIcon} style={{width:"20px", height:"20px"}} alt="match" /> },
    { key: '/search', label: 'Search', icon: <SearchOutlined /> },
    { key: '/mylist-college', label: 'My List', icon: <HeartOutlined /> },
  ];

  const getActiveTabKey = (pathname: string) => {
    if (pathname.startsWith('/recommend')) return '/recommend-college-dream';
    if (pathname.startsWith('/mylist')) return '/mylist-college';
    return pathname;
  };

  const activeTabKey = getActiveTabKey(location.pathname);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest('.menu-button')) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      <div className="bottom-nav">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`nav-item ${activeTabKey === tab.key ? 'active' : ''}`}
            onClick={() => navigate(tab.key)}
            style={{ background: 'none', border: 'none', padding: 0 }}
          >
            {tab.icon}
            <div className="label">{tab.label}</div>
          </button>
        ))}

        <button
          className="nav-item menu-button"
          onClick={() => setMenuOpen(prev => !prev)}
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <img src={menuIcon} alt="menu" />
          <div className="label">Menu</div>
        </button>
      </div>

      {/* Overlay for menu modal */}
      {menuOpen && (
        <div
          className="menu-overlay"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div className={window.location.pathname === "/search" ? `slide-menu-search ${menuOpen ? 'open' : ''}` : `slide-menu ${menuOpen ? 'open' : ''}`} ref={menuRef}>
        <div className="menu-content">
          <button style={{ fontSize: '14px' }} onClick={() => { navigate('/'); setMenuOpen(false); }}>Home</button>
          <button style={{ fontSize: '14px' }} onClick={() => { navigate('/college'); setMenuOpen(false); }}>College</button>
          <button style={{ fontSize: '14px' }} onClick={() => { navigate('/course'); setMenuOpen(false); }}>Majors</button>
          <button style={{ fontSize: '14px' }} onClick={() => { navigate('/role'); setMenuOpen(false); }}>Role</button>
          <button style={{ fontSize: '14px' }} onClick={() => { navigate('/compare-college'); setMenuOpen(false); }}>Compare</button>
        </div>
      </div>
    </>
  );
};
